// Deal Flow → Prequalification → Program Brochure.
//
// The staff surface for the one PDF per role that carries the program detail the
// deal sheets and analyses stopped explaining. Replacing that PDF is how program
// copy is updated without shipping code, which is the entire point of the
// feature — so this page is deliberately small: two panels, one per role, and no
// per-partner scoping (owner ruling 2: one buyer brochure, one seller brochure,
// Phoenix-wide; partner brands serve the Phoenix file).
//
// Gated on Prequalification.ManageDocuments — the same permission as the
// Document Language editor, reused rather than duplicated.

import { PageHeader } from "@/components/layout/PageHeader";
import { ProgramBrochurePanel } from "@/components/prequalification/ProgramBrochurePanel";
import { ResponsiveGrid } from "@/design-system/components/ui";
import { useProgramBrochures } from "@/hooks/prequalification/useProgramBrochures";

const EYEBROW = "Deal Flow · Prequalification";
const TITLE = "Program brochure";

export function ProgramBrochurePage() {
  const query = useProgramBrochures();

  if (query.isLoading) {
    return (
      <>
        <PageHeader eyebrow={EYEBROW} title={TITLE} />
        <div className="text-gray-mid">Loading brochures…</div>
      </>
    );
  }

  if (query.isError || !query.data) {
    return (
      <>
        <PageHeader eyebrow={EYEBROW} title={TITLE} />
        <div className="text-status-error" role="alert">
          Could not load the program brochures.
        </div>
      </>
    );
  }

  return (
    <div className="flex flex-col gap-space-4">
      <PageHeader
        eyebrow={EYEBROW}
        title={TITLE}
        description="One PDF per role, served to applicants as a fourth document and attached to their completion email. It carries the program detail the deal sheets and analyses point at — the transition period, pool entry, vesting, protections, fees and exit paths — so that detail can be updated by replacing a file rather than by shipping code. Uploads are versioned: replacing a brochure keeps the old one, and you can restore it."
      />

      {/* Two columns where the container can give each one a readable width, one
          below that. Reflows on the CONTAINER, not the viewport (Table & Tile
          standard §12), so the panels behave the same on a narrow page. */}
      <ResponsiveGrid cols={2} minColWidth="26rem" gap="lg">
        <ProgramBrochurePanel state={query.data.buyer} />
        <ProgramBrochurePanel state={query.data.seller} />
      </ResponsiveGrid>
    </div>
  );
}
